<div class="mobile-catalogs-grid">
  @if(shop){
  @if (collection$ | async; as collection) {
  <p-accordion [activeIndex]="0">
    <p-accordionTab>
      <ng-template pTemplate="header">
        <div [routerLink]="collection.children?.length > 0 ? null : ['/shop/category', collection.slug]"
          class="catalog-item-header" [class.active]="shop">
          <div class="img-wrapper">
            @if(collection.featuredAsset){
            <img class="collection-image" [src]="collection.featuredAsset | assetPreview:'thumb'"
              alt="{{collection.name}}">
            } @else {
            <img class="collection-image" src="./../../../assets/images/placeholders/no-img-placeholder.svg"
              alt="{{collection.name}}">
            }

          </div>
          <div class="header-content">
            <h2>
              <span class="header-text">{{collection.name}}</span>
              <span class="count">({{collection?.productsCount}})</span>
              @if(collection.customFields.commingSoon){
              <div class="coming-soon-label" [class.oils]="collection.slug == SlugTypes.Oils"
                [class.batteries]="collection.slug == SlugTypes.Batteries">
                Coming soon
              </div>
              }

            </h2>

            <img class="expand-icon" src="./../../../../assets/images/icons/arrow_drop_down_dark.svg" alt="expand">

          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <div class="catalog-content">
          <div class="tab-content">

            @for(child of collection?.children; track child.id){
            <a [routerLink]="['/',vehicleTypeService?.currentVehicleType,'shop','category', child.slug]" [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }">
              <span class="category-text">{{child.name}}</span>
              <span class="count">({{child.productsCount}})</span>

            </a>
            }
          </div>
        </div>
      </ng-template>
    </p-accordionTab>

  </p-accordion>
  }
  }

  @if (!shop) {
  <p-accordion>

    @if(collectionsLoading){
    <div class="loading-wrapper pl-16-px pr-16-px pt-12-px">
      <p-skeleton width="100%" height="65px" [styleClass]="'mb-2-px'"></p-skeleton>
      <p-skeleton width="100%" height="65px" [styleClass]="'mb-2-px'"></p-skeleton>
      <p-skeleton width="100%" height="65px" [styleClass]="'mb-2-px'"></p-skeleton>
      <p-skeleton width="100%" height="65px" [styleClass]="'mb-2-px'"></p-skeleton>
      <p-skeleton width="100%" height="65px" [styleClass]="'mb-2-px'"></p-skeleton>
      <p-skeleton width="100%" height="65px" [styleClass]="'mb-2-px'"></p-skeleton>
      <p-skeleton width="100%" height="65px" [styleClass]="'mb-2-px'"></p-skeleton>
      <p-skeleton width="100%" height="65px" [styleClass]="'mb-2-px'"></p-skeleton>
    </div>
    } @else {
    @for(collection of collections; track collection.id){
    <p-accordionTab>
      <ng-template pTemplate="header">
        <div [routerLink]="collection.children?.length > 0 ? null : ['/shop/category', collection.slug]"
          class="catalog-item-header">
          <div class="img-wrapper">
            @if(collection.featuredAsset){
            <img class="collection-image" [src]="collection.featuredAsset | assetPreview:'thumb'"
              alt="{{collection.name}}">
            } @else {
            <img class="collection-image" src="./../../../assets/images/placeholders/no-img-placeholder.svg"
              alt="{{collection.name}}">
            }
          </div>
          <div class="header-content">
            <h2>
              <span class="header-text">{{collection.name}}</span>
              <span class="count">({{collection?.productsCount}})</span>
              @if(collection.customFields.commingSoon){
              <div class="coming-soon-label" [class.oils]="collection.slug == SlugTypes.Oils"
                [class.batteries]="collection.slug == SlugTypes.Batteries">
                Coming soon
              </div>
              }

            </h2>
            <img class="expand-icon" src="./../../../../assets/images/icons/arrow_drop_down_dark.svg" alt="expand">
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <div class="catalog-content">
          <div class="tab-content">
            @for(child of collection?.children; track child.id){
            <a [routerLink]="['/',vehicleTypeService?.currentVehicleType,'shop','category', child.slug]" [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }">
              <span class="category-text">{{child.name}}</span>
              <span class="count">({{child.productsCount}})</span>
            </a>
            }

          </div>
        </div>
      </ng-template>
    </p-accordionTab>

    }
    }

  </p-accordion>
  }
